import Card from "./Card/Card";
import styles from "./AdvertisingOptions.module.scss";
import { Col, Row } from "reactstrap";

const AdvertisingOptions = () => {
  const cardsData = [
    {
      heading: "Sponsored Products:",
      content:
        "Promote individual products with Sponsored Products, featured prominently in search results and on product detail pages. Increase visibility and sales by targeting customers actively searching.",
      image: "https://placehold.co/185x111?text=Maelano",
    },
    {
      heading: "Sponsored Display:",
      content:
        "Reach targeted audiences on and off our platform with Sponsored Display ads. Boost brand awareness and engage shoppers at various stages of their online journey.",
      image: "https://placehold.co/185x111?text=Maelano",
    },
    {
      heading: "Sponsored Brands:",
      content:
        "Showcase your brand with Sponsored Brands, featuring your logo, custom headline, and multiple products. Enhance brand visibility and consideration across our platform.",
      image: "https://placehold.co/185x111?text=Maelano",
    },
    {
      heading: "Banner Ads:",
      content:
        "Utilize Banner Ads placed strategically throughout our platform to enhance visibility and capture customer attention. Highlight promotions or brand messaging in high-traffic areas",
      image: "https://placehold.co/185x111?text=Maelano",
    },
    {
      heading: "Sponsored Video Ads:",
      content:
        "Promote your products and brand through engaging video content with Sponsored Video Ads. Capture the attention of potential customers by showcasing your offerings in a dynamic and visually appealing way.",
      image: "https://placehold.co/185x111?text=Maelano",
    },
    {
      heading: "Banner Blogs:",
      content:
        "Leverage Banner Blogs to promote your products and brand messages through targeted content placements. Capture customer interest by embedding promotional banners within relevant blog posts.",
      image: "https://placehold.co/185x111?text=Maelano",
    },
  ];

  return (
    <section>
      <div className="fw-semibold fs-5 my-3">Advertising Options</div>
      <div className="bg-white p-4">
        <Row className={styles["advertising-options"]}>
          {cardsData.map((item) => (
            <Col xxl={6} className="pe-xxl-4">
              <Card
                heading={item.heading}
                content={item.content}
                image={item.image}
              />
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default AdvertisingOptions;